import { Sparkles } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useGenerateTaskInstructionMutation } from '@/services/api/tasksService';

interface TaskInstructionDebugButtonProps {
  matterId: string;
  taskId: string;
}

export function TaskInstructionDebugButton({
  matterId,
  taskId,
}: TaskInstructionDebugButtonProps) {
  const [generateInstruction, { isLoading }] =
    useGenerateTaskInstructionMutation();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => generateInstruction({ matterId, taskId })}
          disabled={isLoading}
          className="text-xs text-slate-400 hover:text-blue-600 hover:bg-blue-50"
        >
          <Sparkles
            className={`h-3.5 w-3.5 mr-1 ${isLoading ? 'animate-pulse' : ''}`}
          />
          {isLoading ? 'Generating...' : 'Generate AI Suggestion'}
        </Button>
      </TooltipTrigger>
      <TooltipContent side="top">
        Debug: Trigger AI instruction generation for this task
      </TooltipContent>
    </Tooltip>
  );
}
